import { IDotDanhGiaSelectRequest } from "../../models/request/danh-gia/IDotDanhGiaSelectRequest"
import { IDotDanhGia } from "../../models/response/danh-gia/IDotDanhGia"
import { apiClient } from "../apiClient"


export const DOT_DANH_GIA_RESOURCE = "dot-danh-gia"
export const DOT_DANH_GIA_DELETE_RESOURCE = "dot-danh-gia/{id}"
export const DOT_DANH_GIA_BY_TRUONG_RESOURCE = "dot-danh-gia/truong/{dm_truong_id}/nam-hoc/{nam_hoc}"
export const dotDanhGiaApi = {
    SelectByTruong: (request: IDotDanhGiaSelectRequest) => apiClient.get(`${DOT_DANH_GIA_RESOURCE}/truong/${request.dm_truong_id}/nam-hoc/${request.nam_hoc}`),
    Delete: (id: number) => apiClient.delete(`${DOT_DANH_GIA_RESOURCE}/${id}`),
    Insert: (payload: IDotDanhGia) => apiClient.post(`${DOT_DANH_GIA_RESOURCE}`, payload),
    Update: (payload: IDotDanhGia) => apiClient.put(`${DOT_DANH_GIA_RESOURCE}`, payload),
}